// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__GAZua","header":"PatientBlock_header__GBXr5","label":"PatientBlock_label__20Dnh","option":"PatientBlock_option__2J7Ot"};